import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { db } from '../../firebase';
import { useNavigate } from 'react-router-dom';
import '../../css/TopSelling.css';

function TopSelling() {
    const [topProducts, setTopProducts] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTopProducts = async () => {
            try {
                // Sort products by salesCount in descending order, limit to top 10
                const productsRef = collection(db, "products");
                const q = query(productsRef, orderBy("salesCount", "desc"), limit(10));
                const snapshot = await getDocs(q);

                const productList = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                setTopProducts(productList);
            } catch (error) {
                console.error("Error fetching top selling products: ", error);
            }
        };

        fetchTopProducts();
    }, []);

    const handleShopNow = (id) => {
        navigate(`/detail/${id}`);
    };

    return (
        <div className="products-page-top-selling">
            <div className="products-header-top-selling">
                <h1>Top Selling Products</h1>
                <p>Here are our most popular picks loved by customers!</p>
            </div>

            <div className="products-grid-top-selling">
                {topProducts.length === 0 ? (
                    <p>No top selling products found.</p>
                ) : (
                    topProducts.map((item) => (
                        <div className="product-card-top-selling" key={item.id}>
                            <div className="product-img-container-top-selling">
                                <img src={item.image} alt={item.title} className="product-img-top-selling" />
                            </div>
                            <div className="product-details-top-selling">
                                <p className="product-name-top-selling">{item.title}</p>
                                <p className="product-price-top-selling">Rs.{item.price?.toLocaleString('en-LK')}</p>
                                <p className="product-sales-top-selling">Sold: {item.salesCount || 0}</p>
                                <button
                                    className="shop-button-top-selling"
                                    onClick={() => handleShopNow(item.id)}
                                >
                                    Shop Now
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default TopSelling;
